var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2939_11679",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2939_11679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2594 3.23974C15.0882 3.45363 15.8711 3.78199 16.59 4.20714C16.59 4.20714 16.9363 3.86069 17.3253 3.47167C17.6078 3.18892 17.9911 3.03035 18.3907 3.03035C18.7897 3.03035 19.1731 3.18892 19.4556 3.47167C19.7982 3.81438 20.1778 4.19392 20.5205 4.53663C20.8033 4.81905 20.9618 5.20239 20.9618 5.60153C20.9618 6.0011 20.8033 6.38439 20.5205 6.66681C20.1315 7.05583 19.785 7.40224 19.785 7.40224C20.2102 8.12111 20.5385 8.90397 20.7525 9.73281H21.7906C22.6224 9.73281 23.2969 10.4073 23.2969 11.239V12.7453C23.2969 13.5771 22.6224 14.2516 21.7906 14.2516H20.7525C20.5385 15.0804 20.2102 15.8633 19.785 16.5821C19.785 16.5821 20.1315 16.9285 20.5205 17.3175C20.8033 17.6 20.9618 17.9833 20.9618 18.3828C20.9618 18.782 20.8033 19.1653 20.5205 19.4478C20.1778 19.7904 19.7982 20.17 19.4556 20.5127C19.1731 20.7955 18.7897 20.954 18.3907 20.954C17.9911 20.954 17.6078 20.7955 17.3253 20.5127C16.9363 20.1236 16.59 19.7772 16.59 19.7772C15.8711 20.2023 15.0882 20.5308 14.2594 20.7446V21.7828C14.2594 22.6146 13.5849 23.2891 12.7531 23.2891H11.2469C10.415 23.2891 9.74063 22.6146 9.74063 21.7828V20.7446C8.91183 20.5308 8.12892 20.2023 7.41005 19.7772C7.41005 19.7772 7.06364 20.1236 6.67463 20.5127C6.3922 20.7955 6.00886 20.954 5.60934 20.954C5.2102 20.954 4.82681 20.7955 4.54444 20.5127C4.20178 20.17 3.82219 19.7904 3.47949 19.4478C3.19674 19.1653 3.03816 18.782 3.03816 18.3828C3.03816 17.9833 3.19674 17.6 3.47949 17.3175C3.8685 16.9285 4.21495 16.5821 4.21495 16.5821C3.7898 15.8633 3.46148 15.0804 3.24755 14.2516H2.20941C1.37756 14.2516 0.703125 13.5771 0.703125 12.7453V11.239C0.703125 10.4073 1.37756 9.73281 2.20941 9.73281H3.24755C3.46148 8.90397 3.7898 8.12111 4.21495 7.40224C4.21495 7.40224 3.8685 7.05583 3.47949 6.66681C3.19674 6.38439 3.03816 6.0011 3.03816 5.60153C3.03816 5.20239 3.19674 4.81905 3.47949 4.53663C3.82219 4.19392 4.20178 3.81438 4.54444 3.47167C4.82681 3.18892 5.2102 3.03035 5.60934 3.03035C6.00886 3.03035 6.3922 3.18892 6.67463 3.47167C7.06364 3.86069 7.41005 4.20714 7.41005 4.20714C8.12892 3.78199 8.91183 3.45363 9.74063 3.23974V2.20155C9.74063 1.3697 10.415 0.695314 11.2469 0.695314H12.7531C13.5849 0.695314 14.2594 1.3697 14.2594 2.20155V3.23974Z",
    stroke: "white",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0031 7.47813C14.4971 7.47813 16.5219 9.50289 16.5219 11.9969C16.5219 14.4908 14.4971 16.5156 12.0031 16.5156C9.50914 16.5156 7.48438 14.4908 7.48438 11.9969C7.48438 9.50289 9.50914 7.47813 12.0031 7.47813Z",
    stroke: "white",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.398f09ee3eb6461b5a038ba72219d2f1.svg";
export { ForwardRef as ReactComponent };